import {useAppSelector} from "@Hooks/selector/useAppSelector";
import entries from "@Object/entries";
import PassengerClassSummary
    from "@CheckOrder/features/paymentSummary/features/passengerClassesSummary/components/PassengerClassSummary";

function PassengerClassesSummary() {
    const {
        singleSelectedPassengerClasses,
        returnSelectedPassengerClasses,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    return (
        <>
            {entries(singleSelectedPassengerClasses.classToPassengersMap).map(([passengerClassId, passengerIdsGroups]) => {
                return (
                    <PassengerClassSummary
                        key={`${passengerClassId}-${passengerIdsGroups.join("-")}`}
                        passengerIdsGroups={passengerIdsGroups}
                        passengerClass={singleSelectedPassengerClasses.passengerToPassengerClassMap[passengerIdsGroups[0][0]]}
                    />
                )
            })}
            {entries(returnSelectedPassengerClasses.classToPassengersMap).map(([passengerClassId, passengerIdsGroups]) => {
                return (
                    <PassengerClassSummary
                        key={`${passengerClassId}-${passengerIdsGroups.join("-")}`}
                        passengerIdsGroups={passengerIdsGroups}
                        passengerClass={returnSelectedPassengerClasses.passengerToPassengerClassMap[passengerIdsGroups[0][0]]}
                    />
                )
            })}
        </>
    )
}

export default PassengerClassesSummary